var map = {
	"./map/obs-leaflet.less": 845,
	"./map/obs-search.less": 846,
	"./map/observatoire.less": 847
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 892;


//////////////////
// WEBPACK FOOTER
// ./src/modules/observatoire/css \.(js|ts|less|css)$
// module id = 892
// module chunks = 2 11 12